<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import type { TFeedbackQuestion } from '../types';
import { useFeedback } from '../composable/useFeedback';
import { MUTATION_TYPES } from '../store/storeTypes';
import { MODULE_NAME } from '../constants';
// import { debounce } from '@modules/common';
type Props = {
  question: TFeedbackQuestion;
};
const store = useStore();
const { getResultByQuestion } = useFeedback();
const { question } = defineProps<Props>();
const result = computed(() => {
  return getResultByQuestion(question.id) || { id: question.id, answer: '' };
});

const onChangeText = (event: Event) => {
  store.commit(`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_RESULT}`, {
    questionId: question.id,
    questionType: question.type,
    answer: {
      key: 'FREE_TEXT',
      value: event.target?.value,
      label: '',
    },
  });
};
</script>

<template>
  <textarea
    @input="onChangeText"
    placeholder="Type something..."
    class="!p-2 h-[82px] border border-light-500 border-solid rounded-[3px]" />
</template>
